/** Query flag when milestone pages are opened from therapist client workspace. */
export const CLIENT_CONTROL_RETURN = 'client-control';

export function isClientControlWorkspaceReturn(
  searchParams: URLSearchParams | { get: (key: string) => string | null },
): boolean {
  return searchParams.get('return') === CLIENT_CONTROL_RETURN;
}

export function clientControlHref(kidProfileId: string): string {
  return `/client-control/${kidProfileId}`;
}

export function milestoneTasksHref(
  kidProfileId: string,
  view: 'tile' | 'tasks' = 'tile',
  options?: { returnToClientControl?: boolean },
): string {
  const params = new URLSearchParams({ view });
  if (options?.returnToClientControl) {
    params.set('return', CLIENT_CONTROL_RETURN);
  }
  return `/milestone-tasks/${kidProfileId}?${params.toString()}`;
}

export function milestoneDetailsHref(
  milestoneId: string,
  options?: { taskId?: string; returnToClientControl?: boolean },
): string {
  const params = new URLSearchParams();
  if (options?.taskId) params.set('task', options.taskId);
  if (options?.returnToClientControl) params.set('return', CLIENT_CONTROL_RETURN);
  const query = params.toString();
  return query ? `/milestone-details/${milestoneId}?${query}` : `/milestone-details/${milestoneId}`;
}

export function carePlanHref(
  kidProfileId: string,
  options?: {
    returnToClientControl?: boolean;
    tab?: 'plan' | 'library' | 'overview';
    domain?: string;
  },
): string {
  const params = new URLSearchParams();
  if (options?.returnToClientControl) {
    params.set('return', CLIENT_CONTROL_RETURN);
  }
  if (options?.tab && options.tab !== 'plan') {
    params.set('tab', options.tab);
  }
  if (options?.domain) {
    params.set('domain', options.domain);
  }
  const query = params.toString();
  return query ? `/care-plan/${kidProfileId}?${query}` : `/care-plan/${kidProfileId}`;
}

/** Reuses parent Goal Coach route; therapists pass return=client-control for back navigation. */
export function goalCoachHref(
  kidProfileId: string,
  options?: { returnToClientControl?: boolean },
): string {
  if (options?.returnToClientControl) {
    return `/goal-coach/${kidProfileId}?return=${CLIENT_CONTROL_RETURN}`;
  }
  return `/goal-coach/${kidProfileId}`;
}

export function sessionHistoryHref(kidProfileId: string): string {
  return `/session-history/${kidProfileId}`;
}

export function assessmentHistoryHref(kidProfileId: string): string {
  return `/assessment-history/${kidProfileId}`;
}

export function messagesHref(kidProfileId: string): string {
  return `/messages/${kidProfileId}`;
}

export function addMilestoneHref(kidProfileId: string): string {
  return `/add-milestone/${kidProfileId}`;
}

/** Document Center is a modal (no route) — voice opens the client workspace; user taps Documents. */
export function clientDocumentsHref(kidProfileId: string): string {
  return clientControlHref(kidProfileId);
}

export function bookMeetingHref(): string {
  return '/book-meeting';
}

export function createClientWizardHref(): string {
  return '/client-plan-wizard';
}
